import { render } from "./CourseQuestionSubpage.vue?vue&type=template&id=66433b0c&scoped=true"
import script from "./CourseQuestionSubpage.vue?vue&type=script&lang=js"
export * from "./CourseQuestionSubpage.vue?vue&type=script&lang=js"

import "./CourseQuestionSubpage.vue?vue&type=style&index=0&id=66433b0c&lang=css"
import "./CourseQuestionSubpage.vue?vue&type=style&index=1&id=66433b0c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66433b0c"]])

export default __exports__